import React from 'react';
import { Store } from 'react-redux';
import { Const } from 'survey-react';
import { getAuthToken } from '../../../util/helpers';
const URL=process.env.REACT_APP_API_ENDPOINT_BASE_URL
const REACT_APP_SR_DOC_LINK=process.env.REACT_APP_SR_DOC_LINK

export default function DocsLink() {
  const jwt=getAuthToken()

  return (
   <>
      <iframe src={`${REACT_APP_SR_DOC_LINK}?jwt=${jwt}&url=${URL}`} width="100%" height='900px' frameBorder='0' scrolling='yes'
      marginWidth="0" marginHeight="0" 
       />
   </>
  )
}
